import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "../components/layout/Layout";
import ProtectedRoute from "../components/ProtectedRoute";
import PermissionRoute from "../components/access/PermissionRoute";
import AuthPermissionSync from "../components/access/AuthPermissionSync";

import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Containers from "../pages/Containers";
import Invoices from "../pages/Invoices";
import InvoicePrint from "../pages/InvoicePrint";
import CostPriceList from "../pages/CostPriceList";
import Vendors from "../pages/Vendors";
import Payments from "../pages/Payments";
import Reports from "../pages/Reports";
import Settings from "../pages/Settings";
import Help from "../pages/Help";
import NotFound from "../pages/NotFound";
import Profile from "../pages/Profile";
import InvoiceCreate from "../pages/InvoiceCreate";
import Tracking from "../pages/Tracking";
import TrackShipment from "../pages/TrackShipment";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          element={
            <ProtectedRoute>
              <AuthPermissionSync>
                <Layout />
              </AuthPermissionSync>
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              <PermissionRoute moduleKey="dashboard" action="read">
                <Dashboard />
              </PermissionRoute>
            }
          />

          <Route
            path="containers"
            element={
              <PermissionRoute moduleKey="containers" action="read">
                <Containers />
              </PermissionRoute>
            }
          />

          <Route
            path="tracking"
            element={
              <PermissionRoute moduleKey="tracking" action="read">
                <Tracking />
              </PermissionRoute>
            }
          />

          <Route
            path="track-shipment"
            element={
              <PermissionRoute moduleKey="tracking" action="read">
                <TrackShipment />
              </PermissionRoute>
            }
          />

          <Route
            path="invoices"
            element={
              <PermissionRoute moduleKey="invoices" action="read">
                <Invoices />
              </PermissionRoute>
            }
          />

          <Route
            path="invoices/create"
            element={
              <PermissionRoute moduleKey="invoices" action="create">
                <InvoiceCreate />
              </PermissionRoute>
            }
          />

          <Route
            path="invoices/:id/print"
            element={
              <PermissionRoute moduleKey="invoices" action="read">
                <InvoicePrint />
              </PermissionRoute>
            }
          />

          <Route
            path="cost-price-list"
            element={
              <PermissionRoute moduleKey="cost-prices" action="read">
                <CostPriceList />
              </PermissionRoute>
            }
          />

          <Route
            path="vendors"
            element={
              <PermissionRoute moduleKey="vendors" action="read">
                <Vendors />
              </PermissionRoute>
            }
          />

          <Route
            path="payments"
            element={
              <PermissionRoute moduleKey="payments" action="read">
                <Payments />
              </PermissionRoute>
            }
          />

          <Route
            path="reports"
            element={
              <PermissionRoute moduleKey="reports" action="read">
                <Reports />
              </PermissionRoute>
            }
          />

          <Route
            path="settings"
            element={
              <PermissionRoute moduleKey="settings" action="read">
                <Settings />
              </PermissionRoute>
            }
          />

          <Route
            path="help"
            element={
              <PermissionRoute moduleKey="help" action="read">
                <Help />
              </PermissionRoute>
            }
          />

          <Route
            path="profile"
            element={
              <PermissionRoute moduleKey="profile" action="read">
                <Profile />
              </PermissionRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
